import { createSlice } from '@reduxjs/toolkit';

export const postCreateUpsellSlice = createSlice({
    name: 'postCreateUpsell',
    initialState: {
        isOpen: false,
        item: null,
        table: null,
        advertId: null,
        mode: 'create',
    },
    reducers: {
        openPostCreateUpsell(state, action) {
            const { item, table, advertId, mode } = action.payload || {};
            state.isOpen = true;
            state.item = item || null;
            state.table = table || null;
            state.advertId = advertId || null;
            state.mode = mode === 'edit' ? 'edit' : 'create';
        },
        closePostCreateUpsell(state) {
            state.isOpen = false;
            state.item = null;
            state.table = null;
            state.advertId = null;
            state.mode = 'create';
        },
    },
});

export const { openPostCreateUpsell, closePostCreateUpsell } =
    postCreateUpsellSlice.actions;

export const selectPostCreateUpsell = (state) => state.postCreateUpsell;

export const postCreateUpsell = postCreateUpsellSlice.reducer;
